import React, { useState, useCallback, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import ReactDatePicker, { registerLocale } from 'react-datepicker';
import moment from 'moment';
import localization from 'moment/locale/it';
import { InputError } from 'components/atoms/styleds';
import it from 'date-fns/locale/it';

import CalendarIcon from 'assets/images/calendar_icon.svg';

import {
  Wrapper,
  TimePickerButton,
  TimePickerText,
  TimePickerHelperText,
  TimePickerWrapper,
} from './styled';

moment.updateLocale('it', localization);

const Timepicker = ({
  dateFormat = 'd MMMM',
  helperText,
  onChange,
  selectedDate,
  selectsStart,
  selectsEnd,
  endDate,
  startDate,
  pickerAbsolute = false,
  minDate,
  showMinDate = true,
  error,
  style = {},
}) => {
  const ref = useRef();
  const [open, setOpen] = useState(false);
  const locale = {
    ...it,
  };

  const localOnChange = useCallback(
    (date) => {
      setOpen(false);
      onChange && onChange(date);
    },
    [onChange],
  );

  registerLocale('it-IT', locale);

  const onClickWindow = useCallback(
    (e) => {
      const { current } = ref;
      if (current && !current.contains(e.target)) {
        setOpen(false);
      }
    },
    [ref],
  );

  useEffect(() => {
    window.addEventListener('click', onClickWindow, true);
    return () => {
      window.removeEventListener('click', onClickWindow, true);
    };
  }, [onClickWindow]);

  const onClick = useCallback(() => {
    setOpen((s) => !s);
  }, [ref]);

  return (
    <Wrapper style={style} ref={ref} role='presentation'>
      <TimePickerButton onClick={onClick} type='button'>
        <img src={CalendarIcon} alt='calendar' />
        <TimePickerText failed={!!error}>
          {selectedDate
            ? moment(selectedDate).format('D MMMM')
            : 'Seleziona una data'}
        </TimePickerText>
      </TimePickerButton>
      {!!helperText && (
        <TimePickerHelperText failed={!!error}>
          {helperText}
        </TimePickerHelperText>
      )}
      {!!error && <InputError>{error}</InputError>}
      {open && (
        <TimePickerWrapper
          pos={pickerAbsolute ? 'absolute' : 'relative'}
          onClick={onClick}
        >
          <div onClick={(e) => e.stopPropagation()}>
            <ReactDatePicker
              formatWeekDay={(nameOfDay) => nameOfDay.substr(0, 2)}
              locale='it-IT'
              selected={selectedDate}
              minDate={showMinDate && (minDate || moment().toDate())}
              startDate={startDate}
              endDate={endDate}
              onChange={localOnChange}
              inline={true}
              selectsStart={selectsStart}
              selectsEnd={selectsEnd}
            />
          </div>
        </TimePickerWrapper>
      )}
    </Wrapper>
  );
};

Timepicker.propTypes = {
  dateFormat: PropTypes.string,
  helperText: PropTypes.string,
  selectedDate: PropTypes.instanceOf(Date),
  selectsStart: PropTypes.bool,
  selectsEnd: PropTypes.bool,
  showMinDate: PropTypes.bool,
  error: PropTypes.any,
};

export default Timepicker;
